import { lazy } from 'react';

const SignUpConfirm = lazy(() =>
  import(/* webpackChunkName: "SignUpConfirm" */ '@common2/Authorization/SignUp/SignUpConfirm')
);

export default SignUpConfirm;
